export default __webpack_public_path__ + "static/media/opensea.1f431232.svg";